import script from "./Withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./Withdraw.vue?vue&type=script&setup=true&lang=js"

import "./Withdraw.vue?vue&type=style&index=0&id=5b95aee6&lang=less&scoped=true"
import "./Withdraw.vue?vue&type=style&index=1&id=5b95aee6&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b95aee6"]])

export default __exports__